import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

// import {GoogleOAuthProvider } from '@react-oauth/google';

const availableLanguages = ["en", "fr"];

const browserLang = navigator.language.split("-")[0]; // Extract base language (e.g., "en" from "en-US")
const defaultLanguage = availableLanguages.includes(browserLang) ? browserLang : "en";

i18next
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources: {
    en: {
      translation: translationEN
    },
    fr: {
      translation: translationFR
    }
  },
  lng: localStorage.getItem("i18nextLng") || defaultLanguage, // default language
  fallbackLng: 'en', // fallback language if key not found in selected language
  detection: {
    order: ["localStorage", "cookie", "navigator"],
    caches: ['localStorage', 'cookie'], // Where to store the detected language
  },
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>  
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
  // </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
